export const ADVANTAGES = [
  {
    title: 'Увлечённые гиды',
    text: 'Наши экскурсии проводят увлечённые, общительные люди с большим багажом знаний: историки, архитекторы, журналисты, искусствоведы и другие эксперты.',
  },
  {
    title: 'Необычные экскурсии',
    text: 'Мы любим необычные экскурсии: с нами вы не только узнаете историю города, но и погуляете по его секретным барам, крышам и галереям современного искусства. А ещё приготовите обед с местным шеф-поваром.',
  },
  {
    title: 'Только личное общение',
    text: 'Вся магия и яркие впечатления рождаются в личном общении, поэтому мы специально заботимся о качестве экскурсий. Вы не найдёте у нас гидов со скучными заученными программами.',
  },
];

export const HOW_IT_WORKS = [
  {
    image: 'https://cdn.tripster.ru/photos/about-city.png',
    title: 'Выбирайте экскурсию на сайте',
    text: 'Все экскурсии на сайте авторские, экскурсию проводит человек, который её придумал. Вы можете заранее прочитать описание программы, посмотреть, что гид написал о себе, познакомиться с отзывами других путешественников и выбрать экскурсию, которая вам ближе всего.',
  },
  {
    image: 'https://cdn.tripster.ru/photos/about-cal.png',
    title: 'Можно пообщаться с гидом до оплаты',
    text: 'Бронирование происходит через сайт, при этом вы общаетесь напрямую с гидом и можете задать ему любые вопросы. Вам не нужно ничего оплачивать, пока вы не проясните все важные для себя детали.',
  },
  {
    image: 'https://cdn.tripster.ru/photos/about-card.png',
    title: 'Не нужно платить все деньги сразу',
    text: 'На сайте вы оплачиваете часть стоимости экскурсии, это позволяет гиду забронировать выбранное вами время. Оставшуюся часть стоимости вы оплачиваете гиду на месте после экскурсии.',
  },
];
